import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/employees/list', data, {params})
  },
  listAll() {
    return http.get('/employees')
  },
  changeStatus(id, status) {
    return http.put(`/employees/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/employees', data)
  },
  update(id, data) {
    return http.put(`/employees/${id}`, data)
  },
  get(id) {
    return http.get(`/employees/${id}`)
  },
  queryDni(dni) {
    return http.get(`/employees/dni/${dni}`)
  },
  getCompliance(id) {
    return http.get(`/employees/${id}/compliance`)
  },
}
